import React from 'react';
import { SUPPORT_EMAIL } from './supportContent';

// Interleaves a real mailto <a> anywhere SUPPORT_EMAIL appears in plain
// text, without dangerouslySetInnerHTML. Handles zero, one, or multiple
// occurrences in a single solution string.
function renderSolution(text) {
  if (!text.includes(SUPPORT_EMAIL)) return text;
  const parts = text.split(SUPPORT_EMAIL);
  return parts.flatMap((part, i) =>
    i < parts.length - 1
      ? [part, <a key={i} href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>]
      : [part]
  );
}

// Props are intentionally limited to {issue, solution} — SupportSection
// passes only these two fields, so supportContent.js's `verify` review
// marker can never reach this component or the DOM.
const SupportRow = ({ issue, solution }) => (
  <details className="support-row">
    <summary className="support-row-summary">{issue}</summary>
    <div className="support-row-body">{renderSolution(solution)}</div>
  </details>
);

export default SupportRow;
